(function () {
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function setActiveMessage(messages, index) {
    messages.forEach(function (message, i) {
      var isActive = i === index;
      message.classList.toggle('is-active', isActive);
      message.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function bindBuffAnnouncementBar(root) {
    if (!root || root.dataset.buffAnnouncementBound === 'true') return;
    if (root.hasAttribute('data-single-message')) return;

    var messages = root.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;

    root.dataset.buffAnnouncementBound = 'true';

    var autoplay = root.dataset.autoplay !== 'false';
    var delay = parseInt(root.dataset.autoplayDelay, 10) || 4000;
    var pauseOnHover = root.dataset.pauseOnHover === 'true';
    var prevBtn = root.querySelector('[data-announcement-prev]');
    var nextBtn = root.querySelector('[data-announcement-next]');
    var index = 0;
    var timer = null;

    messages.forEach(function (message, i) {
      message.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });

    function goTo(nextIndex) {
      index = (nextIndex + messages.length) % messages.length;
      setActiveMessage(messages, index);
    }

    function advance() {
      goTo(index + 1);
    }

    function restartAutoplay() {
      stop();
      start();
    }

    function start() {
      if (!autoplay || prefersReducedMotion()) return;
      timer = window.setInterval(advance, delay);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    start();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
        restartAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
        restartAutoplay();
      });
    }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }

    reducedMotionQuery.addEventListener('change', function () {
      if (prefersReducedMotion()) {
        stop();
        goTo(0);
      } else {
        start();
      }
    });
  }

  function initBuffAnnouncementBars(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-buff-announcement-bar]').forEach(bindBuffAnnouncementBar);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBuffAnnouncementBars();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initBuffAnnouncementBars(evt.target);
  });
})();
